// extracted by mini-css-extract-plugin
export var accordionIcon = "body-mod--accordion-icon--305f5";
export var accordionIconOpen = "body-mod--accordion-icon-open--53a42";
export var backBtn = "body-mod--back-btn--a9a8d";
export var badgeContainer = "body-mod--badge-container--90ab0";
export var category = "body-mod--category--bf00f";
export var categoryLinksContainer = "body-mod--category-links-container--fecd7";
export var categoryPage = "body-mod--category-page--37355";
export var categoryTitle = "body-mod--category-title--6ad7e";
export var closeBtn = "body-mod--close-btn--0fae4";
export var combinedLinks = "body-mod--combined-links--986b6";
export var contactLinks = "body-mod--contact-links--26dd5";
export var headerBodyWrapper = "body-mod--header-body-wrapper--328ab";
export var headerDescription = "body-mod--header-description--89e08";
export var headerImage = "body-mod--header-image--0f9be";
export var headerLink = "body-mod--header-link--f1203";
export var headerSlider = "body-mod--header-slider--e47a7";
export var headerText = "body-mod--header-text--500cd";
export var headerTextIcon = "body-mod--header-text-icon--150ea";
export var imgTitle = "body-mod--img-title--31d23";
export var itemContainer = "body-mod--item-container--8c819";
export var language = "body-mod--language--9ce6b";
export var link = "body-mod--link--1c3a3";
export var linkGroup = "body-mod--link-group--6b9ce";
export var linkGroupWrapper = "body-mod--link-group-wrapper--f2961";
export var linksWrapper = "body-mod--links-wrapper--d8d6a";
export var menuItems = "body-mod--menu-items--f0981";
export var navigation = "body-mod--navigation--13f6f";
export var newCategoryPage = "body-mod--new-category-page--07ebb";
export var optDesc = "body-mod--opt-desc--374c2";
export var optIcon = "body-mod--opt-icon--229ed";
export var optImage = "body-mod--opt-image--6695f";
export var optImageWrapper = "body-mod--opt-image-wrapper--56c54";
export var optText = "body-mod--opt-text--03fb0";
export var pdpTitle = "body-mod--pdp-title--c0339";
export var prodGroupData = "body-mod--prod-group-data--6429a";
export var prodImage = "body-mod--prod-image--85d81";
export var prodImageTitle = "body-mod--prod-image-title--8eae4";
export var prodTitleBadge = "body-mod--prod-title-badge--2f721";
export var prodTitleBadgeGroup = "body-mod--prod-title-badge-group--70d19";
export var productContent = "body-mod--product-content--97d8d";
export var productGroupContainer = "body-mod--product-group-container--544d9";
export var singleMenuItem = "body-mod--single-menu-item--83a32";
export var singleProuctInfo = "body-mod--single-prouct-info--804b4";
export var sliderTitle = "body-mod--slider-title--d3771";
export var socialIcons = "body-mod--social-icons--56de3";
export var textLinks = "body-mod--text-links--4eb04";